import React, { useState } from 'react';
import PaymentsOverview from '../components/PaymentsOverview';
import MonthlyReports from '../components/MonthlyReports';
import OrderManagement from '../components/OrderManagement';
import AnalyticsDashboard from '../components/AnalyticsDashboard';
import MenuStockManager from '../components/MenuStockManager';
import '../styles/adminDashboard.css';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = ({ onLogout }) => {
    const [activeTab, setActiveTab] = useState('payments');
    const navigate = useNavigate();

    const handleLogout = () => {
        const confirmLogout = window.confirm('Are you sure you want to logout?');
        if (confirmLogout) {
            localStorage.removeItem('token'); // Remove token
            if (onLogout) onLogout();          // App.js
            navigate('/admin-login');          // Redirect to login page
        }
    };

    const renderTab = () => {
        switch (activeTab) {
            case 'payments':
                return <PaymentsOverview />;
            case 'monthly':
                return <MonthlyReports />;
            case 'orders':
                return <OrderManagement />;
            case 'analytics':
                return <AnalyticsDashboard />;
            case 'stock':
                return <MenuStockManager />;
            default:
                return <PaymentsOverview />;
        }
    };

    return (
        <div className="admin-dashboard">
            <div className="dashboard-header">
                <h1>Admin Dashboard</h1>
                <button className="logout-btn" onClick={handleLogout}>
                    Logout
                </button>
            </div>

            <div className="tab-buttons">
                <button
                    className={activeTab === 'payments' ? 'active' : ''}
                    onClick={() => setActiveTab('payments')}
                >
                    Payments
                </button>
                <button
                    className={activeTab === 'monthly' ? 'active' : ''}
                    onClick={() => setActiveTab('monthly')}
                >
                    Monthly Reports
                </button>
                <button
                    className={activeTab === 'orders' ? 'active' : ''}
                    onClick={() => setActiveTab('orders')}
                >
                    Order Management
                </button>
                <button
                    className={activeTab === 'stock' ? 'active' : ''}
                    onClick={() => setActiveTab('stock')}
                >
                    Menüverwaltung
                </button>
                <button
                    className={activeTab === 'analytics' ? 'active' : ''}
                    onClick={() => setActiveTab('analytics')}
                >
                    Analytics
                </button>
            </div>

            <div className="tab-content">{renderTab()}</div>
        </div>
    );
};

export default AdminDashboard;
